import React, { useState, useEffect } from "react";
import { Tab, Tabs } from "@mui/material";
import GenericRootCauseAnalysisPaginatedDataTable from "../../pages/ResearchQuery/GenericRootCauseAnalysisPaginatedDataTable";

export interface IGenericResearchQueryResults {
  rootCauseAnalysisData: any;
  isLoading: boolean;
  isFilterHide: boolean;
  resourceKeys: any;
  dashboardData: any;
  pageN: number;
  setPageN: React.Dispatch<React.SetStateAction<any>>;
  pageS: number;
  setPageS: React.Dispatch<React.SetStateAction<any>>;
  totalPages: number;
}

/**
 * GenericResearchQueryResults component for displaying generic research query results
 *
 * @param rootCauseAnalysisData - Data for root cause analysis
 * @param isLoading - Loading state
 * @param isFilterHide - Filter visibility state
 * @param resourceKeys - Resource keys for filtering
 * @param dashboardData - Dashboard data containing research query results
 * @param pageN - Current page number
 * @param setPageN - Function to set page number
 * @param pageS - Page size
 * @param setPageS - Function to set page size
 * @param totalPages - Total number of pages
 */
const GenericResearchQueryResults = ({
  rootCauseAnalysisData,
  isLoading,
  isFilterHide,
  resourceKeys,
  dashboardData,
  pageN,
  setPageN,
  pageS,
  setPageS,
  totalPages,
}: IGenericResearchQueryResults) => {
  const [selectedQueryTab, setSelectedQueryTab] = useState<any>("");

  useEffect(() => {
    if (
      dashboardData?.research_query_results &&
      Object.keys(dashboardData.research_query_results).length > 0
    ) {
      const firstKey = Object.keys(dashboardData.research_query_results)[0];
      setSelectedQueryTab(firstKey);
    }
  }, [dashboardData]);

  const handleChangeQueryTab = (
    _event: React.SyntheticEvent,
    newValue: string
  ) => {
    setSelectedQueryTab(newValue);
  };

  return (
    <>
      <Tabs
        value={selectedQueryTab}
        onChange={handleChangeQueryTab}
        textColor="secondary"
        indicatorColor="secondary"
        className="mui-tabs no-t-lr-radius min-height-0 alternative-1"
        variant="scrollable"
        scrollButtons="auto"
      >
        {dashboardData?.research_query_results &&
        typeof dashboardData.research_query_results === "object" &&
        !Array.isArray(dashboardData.research_query_results) ? (
          Object.keys(dashboardData.research_query_results)
            .filter(
              (key) =>
                typeof dashboardData.research_query_results[key] !== "boolean"
            )
            .map((key) => <Tab key={key} value={key} label={String(key)} />)
        ) : (
          <></> // or <Tab label="No data available" disabled />
        )}
      </Tabs>

      {
        <GenericRootCauseAnalysisPaginatedDataTable
          rootCauseData={rootCauseAnalysisData}
          isLoading={isLoading}
          isFilterHide={isFilterHide}
          resourceKeys={resourceKeys}
          pageN={pageN}
          setPageN={setPageN}
          pageS={pageS}
          setPageS={setPageS}
          totalPages={totalPages}
          selectedQueryTab={selectedQueryTab}
        />
      }
    </>
  );
};

export default GenericResearchQueryResults;
